import { route } from "@circle-react/lib/routes/define";

export const liveStreamsRoutes = {
  index: route("/settings/live_streams", {
    title: "Live streams",
    requires: "admin",
    description:
      "Browse past live events, access recordings, track usage, and start new live streams.",
    queryParams: {
      page: {
        type: "number",
        description:
          "Pagination page number (1-indexed). Omit or pass 1 for the first page.",
      },
      filter: {
        type: "object",
        description:
          "Filter the live-stream list. All sub-fields optional; combine to narrow results.",
        properties: {
          name: {
            type: "string",
            description: "Substring match on live stream name.",
          },
          status: {
            type: "string",
            description:
              "Room status. Accepts a single value, comma-separated list, or array. Allowed values: initializing, backstage, active, inactive, closing, scheduled.",
          },
          room_type: {
            type: "string",
            description:
              "Room type. Accepts a single value, comma-separated list, or array. Allowed values: stream, conference.",
          },
          closed: {
            type: "boolean",
            description:
              "Filter by whether the room has closed (`closed_at IS NOT NULL`). `true` shows only closed rooms; `false` shows only open rooms.",
          },
          recording: {
            type: "boolean",
            description:
              "When `true`, show only rooms with at least one attached recording. `false` is a no-op (returns the unfiltered scope).",
          },
          live_at: {
            type: "object",
            description:
              "Time-range filter on when the stream went live. Values are UNIX timestamps in milliseconds (matches the BE's `to_i / 1000.0` conversion).",
            properties: {
              gte: {
                type: "number",
                description:
                  "Lower bound (inclusive) on stream live-at time, as a UNIX timestamp in milliseconds.",
              },
              lte: {
                type: "number",
                description:
                  "Upper bound (inclusive) on stream live-at time, as a UNIX timestamp in milliseconds.",
              },
            },
          },
        },
      },
      order: {
        type: "object",
        description:
          "Sort the live-stream list. Each key is a sortable column; each value is 'asc' or 'desc'. Multiple keys compose into a multi-column sort. Defaults to `live_at: desc` when omitted.",
        properties: {
          name: {
            type: "string",
            description: "Sort by stream name. Value must be 'asc' or 'desc'.",
          },
          room_type: {
            type: "string",
            description: "Sort by room type. Value must be 'asc' or 'desc'.",
          },
          status: {
            type: "string",
            description: "Sort by status. Value must be 'asc' or 'desc'.",
          },
          live_at: {
            type: "string",
            description:
              "Sort by when the stream went live. Value must be 'asc' or 'desc'.",
          },
        },
      },
    },
  }),

  detail: route("/settings/live_streams/:id", {
    title: "Live stream details",
    requires: "admin",
    description:
      "Detail surface for a specific live stream (participants, recording, chat transcript modals open here).",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the live stream.",
      },
    },
  }),
};
